<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages" >
                    <section v-for="ecole in listeEcoles" :key="ecole.id">
                        <div class="Fiche" v-if="ecole.acf.type == 'École de secteur'">
                            <div class="Infos Contact">
                                <h4>{{ecole.acf.nom }}</h4>
                                <a :href="ecole.acf.adresse_lien">{{ecole.acf.adresse}}</a>
                                <p class="paragraphe" v-html="ecole.acf.description"></p>
                                <a :href="ecole.acf.lien" v-if="ecole.acf.lien != ''"><i>{{ecole.acf.lien}}</i></a>
                                <h4>Contacter</h4>
                                <p>Tel : <a :href="'tel:'+ecole.acf.numero">{{ecole.acf.numero}}</a></p>
                                <br>
                                <br>
                                <section>
                                    <h4>Horaires</h4>
                                    <table class="FicheHoraire">
                                        <tbody>
                                            <tr v-for="jour in ecole.acf.horaires.body" :key="jour.id">
                                                <th v-for="colonne in jour" :key="colonne.id">{{colonne.c}}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </section>
                                <section class="Derniere-actus" v-if="ecole.acf.actualites != ''">
                                    <h4>Actualité de l'école</h4>
                                    <div>
                                        <div  v-for="actualite in listeActualites" :key="actualite.id">
                                            <div v-if="actualite.id == ecole.acf.actualites[0]" class="encadre carte">
                                                <div v-if="actualite.image != ''">
                                                    <img :src="actualite.image" alt="Mairie de QUENNE">
                                                </div>

                                                <section class="contenu-carte">
                                                    <h5>{{actualite.titre}}</h5>
                                                    <p><span>{{actualite.texte | liveSubstr(150)}}
                                                    </span></p>
                                                    <router-link :to="{name: 'Publication', params: {id : actualite.id}}" class="button-carte">
                                                        <span >EN SAVOIR +</span>
                                                    </router-link>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div class="arret-bus">
                                <div class="contenu-droit-page">
                                    <iframe :src="ecole.acf.adresse_lien_iframe" style="border: none" height="100%" width="100%"></iframe>
                                </div>
                                <div class="contenu-droit-page">
                                    <img :src="ecole.acf.image" height="100%" width="100%">
                                </div>
                            </div>
                        </div>
                    </section>
                </section>

                <section class="Section-pages" >
                    <section v-for="ecole in listeEcoles" :key="ecole.id">
                        <div class="Fiche" v-if="ecole.acf.type == 'Collège de secteur'">
                            <div class="Infos Contact">
                                <h4>{{ecole.acf.nom }}</h4>
                                <a :href="ecole.acf.adresse_lien">{{ecole.acf.adresse}}</a>
                                <p class="paragraphe" v-html="ecole.acf.description"></p>
                                <p v-if="ecole.acf.lien != ''">Pour en savoir plus c'est <a :href="ecole.acf.lien">ici</a>.</p>
                                <h4>Contacter</h4>
                                <p>Tel : <a :href="'tel:'+ecole.acf.numero">{{ecole.acf.numero}}</a></p>
                                <section class="Derniere-actus" v-if="ecole.acf.actualites != ''">
                                    <h4>Actualité de l'école</h4>
                                    <div>
                                        <div  v-for="actualite in listeActualites" :key="actualite.id">
                                            <div v-if="actualite.id == ecole.acf.actualites[0]" class="encadre carte">
                                                <div v-if="actualite.image != ''">
                                                    <img :src="actualite.image" alt="Mairie de QUENNE">
                                                </div>

                                                <section class="contenu-carte">
                                                    <h5>{{actualite.titre}}</h5>
                                                    <p><span>{{actualite.texte | liveSubstr(150)}}
                                                    </span></p>
                                                    <router-link :to="{name: 'Publication', params: {id : actualite.id}}" class="button-carte">
                                                        <span >EN SAVOIR +</span>
                                                    </router-link>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div class="arret-bus">
                                <div class="contenu-droit-page">
                                    <iframe :src="ecole.acf.adresse_lien_iframe" style="border: none" height="100%" width="100%"></iframe>
                                </div>
                                <div class="contenu-droit-page">
                                    <img :src="ecole.acf.image" height="100%" width="100%">
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'ecole',
    data () {
        return{
            listeEcoles:{
                id: 0,
                acf:{
                    type: null,
                    titre: null,
                    descritption: null,
                    image: null,
                    lien: null,
                }
            },
            listeActualites:{
                id: 0,
                titre: null,
                texte: null,
                date: null,
                date_comparaison: null,
                mots_cles:{
                    term_id:0,
                    name:null
                },
                image: null,
                album: 0
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.hostacf+'scolaire')
        .then(response =>{
        this.listeEcoles = response.data;
            console.log('listeEcole', this.listeEcoles)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Scolarité'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'actualite/v1/listeActualites')
        .then(response =>{
            this.listeActualites = response.data;
            let actu = new Array
            let j = 0
            for(var i = 0; this.listeActualites.length > i; i++){
                this.dateSplit = this.listeActualites[i].date.split('/');
                this.listeActualites[i].date_comparaison = this.dateSplit[2]+'-'+this.dateSplit[1]+'-'+this.dateSplit[0];
                if(this.listeActualites[i].date_comparaison > this.dateJourCompa){
                    actu[j] = this.listeActualites[i]
                    j++;
                }
            }
            
            this.listeActualitesFuture = actu;
        })
        .catch(error => console.log(error))
    },

    computed:{
        ActuFilterByDate: function(){
            function compare(a, b){
                if(a.date_comparaison < b.date_comparaison) return -1
                if(a.date_comparaison > b.date_comparaison) return 1
                return 0
            }
            return this.listeActualitesFuture.sort(compare)
        }
    },

    filters : {
        liveSubstr: function(string, nb){
            return string.substring(0,nb) + '...';
        },
    }

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Scolaire.vue